export default function createPasswordLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `password:${input.type}` });
    return {
        detected(details) {
            return log({
                type: "detected",
                details,
            });
        },
        fillSkipped(reason) {
            return log({
                type: "fill-skipped",
                details: { reason },
            });
        },
        filled(password) {
            return log({
                type: "filled",
                details: { password },
            });
        },
        submitSkipped(details) {
            return log({
                type: "submit-button:click-skipped",
                details,
            });
        },
        submitClicked() {
            return log({
                type: "submit-button:clicked",
            });
        },
        incorrect(assessmentInfo, password) {
            return log({
                type: "incorrect",
                details: { assessmentInfo, password },
            });
        },
    };
}
